// import { http } from "@/libs/axios.js";
import Vue from 'vue'
export function getHulunbuirProduct() {
  return Vue.$axios.$post('/special/product/bulun-buir');
}

// 申请开店
export function applyOpening() {
  return Vue.$axios.$post('/member/distributor/open-shop');
}



/**
 * 
 * @param {object} data 
 * @param {string} data.no
 * 
 * @returns { Promise<{code: number, data: import('./model/topic').GetTopicTempResult, msg: string}> }
 */
export function getTopicTemp(data) {
  return Vue.$axios.$post('/special/topic', { data })
}
